import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'

const available = (record) => hasAvailableAction(record, 'migrate_to_xplor')

// eslint-disable-next-line react/display-name
const migrateForm = ({ gov_record }) => () => (
  <fieldset>
    Once {gov_record.ChildFirstName || 'this child'} is migrated, Xplor will be responsible for CCMS attendance submissions
  </fieldset>
)

const apiEndPoint = ({ gov_id }) => (
  process.env.REACT_APP_API_HOST + `/api/gov-enrolments/${gov_id}/update-sp-id`
)

const migrateToXplor = ({ record }) => (
  available(record) ?
    {
      label: 'Migrate to Xplor',
      value: 'migrate_xplor',
      component: migrateForm(record),
      url: apiEndPoint(record)
    } :
    null
)

export default migrateToXplor


// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/migrate-to-xplor.js